import PropTypes from 'prop-types';
import React from 'react';
import { ugcRatingShape } from '@bibliocommons/bc-prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { RatingControl } from 'app/components/shared/Rating';

export class UserRatingDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleUpdateRating(rating) {
    const { metadataId, itemPosition, itemPositionGrouped, totalCount, userRating, ratingsActions } = this.props;

    if (userRating) {
      return ratingsActions.changeItemRating(metadataId, rating);
    }

    return ratingsActions.rateItem(metadataId, rating, {
      ui_content_position: itemPosition,
      ui_content_position_grouped: itemPositionGrouped,
      ui_content_position_grouped_count: totalCount
    });
  }

  handleRemoveRating() {
    return this.props.ratingsActions.removeItemRating(this.props.metadataId, this.props.userRating.get('id'));
  }

  handleSelect(rating) {
    if (rating > 0) {
      this.handleUpdateRating(rating);
    } else {
      this.handleRemoveRating();
    }
  }

  render() {
    const { metadataId, userRating, ratingsTransactions, size, useLibraryBranding } = this.props;
    const rating = userRating ? userRating.get('rating') : 0;
    const isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);

    return (
      <RatingControl
        className="cp-user-rating-dropdown"
        handleSelect={this.handleSelect}
        rating={rating}
        isLoading={isLoading}
        size={size}
        useLibraryBranding={useLibraryBranding}
      />
    );
  }
}

UserRatingDropdown.propTypes = {
  itemPosition: PropTypes.number,
  itemPositionGrouped: PropTypes.number,
  metadataId: PropTypes.string.isRequired,
  totalCount: PropTypes.number,
  userRating: ugcRatingShape,
  ratingsActions: PropTypes.objectOf(PropTypes.func),
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  size: PropTypes.oneOf(['default', 'extra-extra-small', 'extra-small', 'small', 'medium', 'large']),
  useLibraryBranding: PropTypes.bool
};

export default UserRatingDropdown;
